import Header from "../layout/header";

function PageNotFound() {
  return (
    <div>
        <Header/>
        <h1>404</h1>
    </div>
  );
}

export default PageNotFound;
